import { render, staticRenderFns } from "./ProductionProvisions.vue?vue&type=template&id=0083fbac"
import script from "./ProductionProvisions.vue?vue&type=script&lang=js"
export * from "./ProductionProvisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports